module.exports = __webpack_public_path__ + "site/img/slogo.42bfcb52.png";